import axios from "axios";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import { Typography, Flex, Button } from "antd";
import Layout from "../layout/Layout";
import { CustomSpinner, CustomTable } from "../utils/CustomComponents";
import { EditFilled, PlusCircleFilled } from "@ant-design/icons";
const { Text } = Typography;

const MechanicList = ({ history }) => {
	const [loading, setLoading] = useState(true);
	const [mechanicList, setMechanicList] = useState([]);

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "",
			dataIndex: "edit",
			width: 100,
			render: (_, record) => {
				return (
					<Button
						type="primary"
						icon={<EditFilled twoToneColor={"white"} />}
						onClick={(e) => history.push(`/mechanic/${record.id}`)}
					/>
				);
			},
		},
		{
			title: "Name",
			dataIndex: "name",
			key: "name",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Email",
			dataIndex: "email",
			key: "email",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
	];

	useEffect(() => {
		getMechanicList();
	}, []);

	const getMechanicList = async () => {
		setLoading(true);

		const url = api + "/user/list/57Concrete/Mechanic";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item, index) => {
					list.push({
						key: index,
						id: item._id,
						name: item.name,
						email: item.email,
					});
				});
				setMechanicList(list);
			}
			setLoading(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const addNewMechanic = () => {
		history.push("/newmechanic");
	};

	const RenderTable = () => {
		return (
			<Flex gap={"middle"} vertical>
				<Button
					onClick={addNewMechanic}
					type="primary"
					style={{
						width: 150,
					}}
					icon={<PlusCircleFilled />}
				>
					New Mechanic
				</Button>
				<CustomTable columns={columns} data={mechanicList} />
			</Flex>
		);
	};

	return (
		<Layout title="Mechanics" description="Mechanic List">
			<Flex vertical gap={"large"}>
				{loading ? <CustomSpinner /> : <RenderTable />}
			</Flex>
		</Layout>
	);
};

export default MechanicList;
